import { useState } from "react";
import { Controller, useFormContext, useFieldArray } from "react-hook-form";
import { Button, Grid, IconButton, Stack } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import SelectCultura from "../../../../../../../components/SelectsSimpleApiQuery/SelectCultura";
import SelectPraga from "../../../../../../../components/SelectsSimpleApiQuery/SelectPraga";
import {ICultura} from "../../../../MICulturas/ListarCulturas/Listagem";
import {IPraga} from "../../../../MIPragas/ListarPragas/Listagem";
import {enqueueSnackbar} from "notistack";


export default function Relacionamentos() {
    const { control, getValues, handleSubmit } = useFormContext();
    const onSubmit = getValues("funcoesAux.onSubmit");

    const { fields, prepend, remove } = useFieldArray({
        control,
        name: "step02.relacionamentos"
    });

    const handleAddRow = () => {
        prepend({ cultura: null, praga: null });
    };

    const handlePrevious = () => {
        const previousStep = getValues("funcoesAux.onBack");
        if (typeof previousStep === "function") previousStep();
    };

    return (
        <>
            {fields.map((field, index) => (
                <Grid container spacing={2} key={field.id} mb={1} alignItems='center'>
                    <Grid size={{xs: 12, md: 5}}>
                        <Controller
                            name={`step02.relacionamentos.${index}.cultura`}
                            control={control}
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { invalid } }) => (
                                <SelectCultura
                                    required
                                    unique_select={true}
                                    value={field.value}
                                    onChange={(value) => {
                                        const selected = Array.isArray(value) ? value[0] : value;
                                        const allRows = getValues("step02.relacionamentos") || [];
                                        const isDuplicate = allRows.some(
                                            (row: any, i: number) =>
                                                i !== index && row?.cultura?.id === selected?.id
                                        );
                                        if (isDuplicate) {
                                            enqueueSnackbar("Cultura já selecionada.", { variant: "warning" });
                                            return;
                                        }
                                        field.onChange(selected);
                                    }}
                                    error={invalid}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 5}}>
                        <Controller
                            name={`step02.relacionamentos.${index}.pragas`}
                            control={control}
                            rules={{ required: "Campo obrigatório" }}
                            render={({ field, fieldState: { invalid } }) => (
                                <SelectPraga
                                    required
                                    value={field.value}
                                    onChange={(value) => field.onChange(Array.isArray(value) ? value : value ? [value] : null)}
                                    error={invalid}
                                />
                            )}
                        />
                    </Grid>
                    <Grid size={{xs: 12, md: 2}}>
                        {index === 0 && (
                            <IconButton onClick={handleAddRow}>
                                <Add />
                            </IconButton>
                        )}
                        {index !== 0 && (
                            <IconButton onClick={() => remove(index)}>
                                <Delete />
                            </IconButton>
                        )}
                    </Grid>
                </Grid>
            ))}
            <Stack direction="row" justifyContent="flex-start" mt={2}>
                <Button variant="outlined" onClick={handlePrevious} sx={{ mr: 2 }}>
                    Voltar
                </Button>
                <Button variant="contained" onClick={handleSubmit(onSubmit)}>
                    Finalizar
                </Button>
            </Stack>
        </>
    );
}

interface Row {
    cultura: ICultura | null;
    praga: IPraga[] | null;
}